enum SubsType {
  AGGREGATOR_FX = "ca",
  AGGREGATOR = "aam",
  AGGREGATOR_CRYPTO = "xas",
  TRADE = "trade",
  FMV = "fmv",
  QUOTES = "quote",
  BLOFIN = "blofin-crypto",
}
export const CANVAS_EDIT_CSS = "main.8729d913";
export const CANVAS_EDIT_JS = "main.a29c804d";
export const PIO_CONST = {
  EVENT_NAME: {
    SUBSCRIBE: "subscribe",
    UNSUBSCRIBE: "unsubscribe",
  },
  SUBS_TYPE: {
    AGGREGATOR: "aam" as SubsType,
    AGGREGATOR_FX: "ca" as SubsType,
    AGGREGATOR_CRYPTO: "xas" as SubsType,
    TRADE: "trade" as SubsType,
    FMV: "fmv" as SubsType,
    QUOTES: "quote" as SubsType,
    BLOFIN: "blofin-crypto" as SubsType,
  },
  SUBS_TOPICS: {
    AGGREGATOR_FX: "ca-msg",
    AGGREGATOR: "aam-msg",
    AGGREGATOR_CRYPTO: "xas-msg",
    TRADE: "trade-msg",
    FMV: "fmv-msg",
    QUOTES: "quote-msg",
  },
};

export type PIOAggregatesPerMinute = {
  ev: "AM";
  sym: string;
  v: number;
  av: number;
  op: number;
  vw: number;
  o: number;
  c: number;
  h: number;
  l: number;
  a: number;
  z: number;
  s: number;
  e: number;
};

export type PIOFxAggregatesPerMinute = {
  ev: "CA";
  pair: string;
  o: number;
  c: number;
  h: number;
  l: number;
  v: number;
  s: number;
};

export type PIOCryptoAggregatesPerSecond = {
  ev: "XAS";
  pair: string;
  o: number; //The open price for this aggregate window
  c: number; //The close price for this aggregate window
  h: number; //The high price for this aggregate window
  l: number; //The low price for this aggregate window
  v: number; //The volume of trades during this aggregate window
  vw: number; //The volume weighted average price
  s: number; //The start timestamp of this aggregate window in Unix Milliseconds
  e: number; //The end timestamp of this aggregate window in Unix Milliseconds
  z: number; //The average trade size for this aggregate window
};
export type PIOCryptoAggregatesPerMinute = {
  ev: "XA";
  pair: string;
  o: number; //The open price for this aggregate window
  c: number; //The close price for this aggregate window
  h: number; //The high price for this aggregate window
  l: number; //The low price for this aggregate window
  v: number; //The volume of trades during this aggregate window
  vw: number; //The volume weighted average price
  s: number; //The start timestamp of this aggregate window in Unix Milliseconds
  e: number; //The end timestamp of this aggregate window in Unix Milliseconds
  z: number; //The average trade size for this aggregate window
};

export type PIOAggregatesPerSecond = {
  ev: "A";
  sym: string;
  v: number;
  av: number;
  op: number;
  vw: number;
  o: number;
  c: number;
  h: number;
  l: number;
  a: number;
  z: number;
  s: number;
  e: number;
};
export type PIOAggregates =
  | PIOAggregatesPerMinute
  | PIOAggregatesPerSecond
  | PIOFxAggregatesPerMinute
  | PIOCryptoAggregatesPerMinute
  | PIOCryptoAggregatesPerSecond;
export type PIOFxAggregates =
  | PIOFxAggregatesPerMinute
  | PIOCryptoAggregatesPerSecond;
export type PIOTrade = {
  ev: "T";
  sym: string;
  x: number;
  i: string;
  z: number;
  p: number;
  s: number;
  c: number[];
  t: number;
  q: number;
};
export type PIOQuote = {
  ev: "Q";
  sym: string;
  bx: number;
  bp: number;
  bs: number;
  ax: number;
  ap: number;
  as: number;
  c: number;
  i: number[];
  t: number;
  q: number;
  z: number;
};
export type PIOFairMarketValue = {
  ev: "FMV";
  val: number;
  sym: string;
  t: number;
};
export type PIOEvents =
  | PIOAggregatesPerMinute
  | PIOFxAggregatesPerMinute
  | PIOAggregatesPerSecond
  | PIOTrade
  | PIOQuote
  | PIOFairMarketValue;
export type SIOSubscription = {
  type: SubsType;
  symbols: string[];
};
